import { FC, useState, createContext, useContext, useCallback } from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useSearchParams } from 'react-router-dom'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [searchParams] = useSearchParams()
  const idCliente = Number(searchParams.get('cliente'))
  const filtroCliente = `cliente:${idCliente}`

  // O filtro do empregador vai sempre no `search`, já desde o primeiro request.
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    search: filtroCliente,
    fixedSort: [{ field: 'nome', order: 'asc' }],
  })

  // Só recompõe o `search` quando ele vem no update; ordenar/paginar mantém a busca atual.
  const updateState = useCallback(
    (updates: Partial<QueryState>) => {
      setState((prev) => ({
        ...prev,
        ...updates,
        search:
          'search' in updates
            ? [filtroCliente, updates.search].filter(Boolean).join(',')
            : prev.search,
      }))
    },
    [filtroCliente]
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
